import Analytics from 'utils/googleAnalytics'

import { CardType } from 'types/deck'
import { PRICE_NAMES, PRICE_SOURCE } from 'types/active'

import { useAppSelector } from 'app-redux/hooks'

import {
  CardKingdomSvg,
  TcgPlayerSvg,
  CardHoarderSvg,
  CardMarketSvg,
  SCGSimpleSvg,
  ManaPoolSvg,
  TCGLandSvg,
  CardTraderSvg,
  JourneysEndSvg,
  CardsphereSvg,
} from 'components/icons/PriceSvgs'

import { getPriceStringAndUrl } from 'utils/Price'

import styles from './prices.module.scss'

const Icons: Record<number, any> = {
  1: CardKingdomSvg,
  2: TcgPlayerSvg,
  3: CardHoarderSvg,
  4: CardMarketSvg,
  5: SCGSimpleSvg,
  6: ManaPoolSvg,
  7: TCGLandSvg,
  8: CardTraderSvg,
  9: JourneysEndSvg,
  10: CardsphereSvg,
}

type Props = {
  card: CardType
  className?: string
}

const Prices = ({ card, className = '' }: Props) => {
  const priceSource = useAppSelector(state => state.active.priceSource)

  return (
    <div className={`${styles.container} ${className}`}>
      <Price card={card} priceSource={priceSource[0]} />
      <Price card={card} priceSource={priceSource[1]} className={styles.priceTwo} />
      <Price card={card} priceSource={priceSource[2]} className={styles.priceThree} />
    </div>
  )
}

export default Prices

type PriceProps = {
  card: CardType
  priceSource: number
  className?: string
}

export const Price = ({ card, priceSource, className = '' }: PriceProps) => {
  const { price, url, affiliateName } = getPriceStringAndUrl(card, priceSource, card.modifier !== 'Normal')
  const priceName = PRICE_NAMES[priceSource]

  const writeAnalytics = () =>
    Analytics.signalEvent(`Opened storefront ${priceName} (single) affiliate=${affiliateName}`)

  if (priceSource === PRICE_SOURCE.NONE) return null

  const Icon = Icons[priceSource]

  return (
    <a
      className={`${styles.price} ${className}`}
      title={priceName}
      href={url}
      onClick={writeAnalytics}
      rel="noopener noreferrer"
      tabIndex={priceSource === PRICE_SOURCE.NONE ? -1 : undefined}
      target="_blank">
      {Icon && (
        <Icon
          height={15}
          width={15}
          viewBox="0 0 45 30"
          preserveAspectRatio="xMidYMid meet"
          alt={`price source ${priceSource}`}
        />
      )}{' '}
      {priceSource === PRICE_SOURCE.NONE ? null : price}
    </a>
  )
}
